import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/ReportingCycleCollisions'
import { format } from '@/utils/StringUtilities'
import { formatDate } from '@/utils/dateUtilities'
import find from 'lodash/find'
import LoadingIndicator from '@/components/LoadingIndicator'

class DetailCollisionDates extends React.Component {
  componentDidMount () {
    this.fetchCollisionDates()
  }
  componentDidUpdate (prevProps, prevState) {
    const colDates = this.findCollisionDates(this.props.reportingCycleId)

    const shouldLoad = (colDates === null) || (colDates.fetching === false && colDates.fetched === false && colDates.error === null)
    if (shouldLoad) { this.fetchCollisionDates() }
  }
  fetchCollisionDates () {
    this.props.getCollisionDates(this.props.reportingCycleId)
  }
  findCollisionDates (id) {
    return find(this.props.reportingCycleCollisions.collisionDates, x => x.reportingCycleId === id)
  }
  render () {
    const collisionDates = this.findCollisionDates(this.props.reportingCycleId)
    const isLoading = (this.props.isLoading) || (collisionDates === null) || ((collisionDates || {}).fetching === true)

    const dates = (collisionDates || {}).dates || []
    const title = format(this.props.localize('Reporting.OccurencesOnHoliday'), dates.length)
    return (
      <div className='col-md-5'>
        <h5>{title}</h5>
        <div className='occurrences-on-holiday'>
          {isLoading && <LoadingIndicator />}
          {!isLoading && dates.map((date, index) => <a key={index} className='badge badge-pill badge-danger'><span>{formatDate(date, 'D.M.')}</span></a>)}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    reportingCycleCollisions: state.reportingCycleCollisions,
    ...ownProps
  }
}

const mapDispatchToProps = {
  getCollisionDates: actionCreators.getCollisionDates
}

export default connect(mapStateToProps, mapDispatchToProps)(DetailCollisionDates)



// WEBPACK FOOTER //
// ./src/internal-app/pages/reportingCycles/collisionDates/detailCollisionDates.js